import * as React from 'react';
import Box from '@mui/material/Box';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import {GoogleIcon, SitemarkIcon} from './CustomIcons';
import './SignInCard.scss';
import Alert from '@mui/material/Alert';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SignInContext from "../../contexts/SignInContext";
import Auth from "../../common/auth/auth";
import { loadGisScript } from "../../common/auth/login-helpers/google-login-helper";
import FormLabel from "@mui/material/FormLabel";
import {Checkbox, FormControl, FormControlLabel, Link, TextField} from "@mui/material";
import ForgotPassword from "./ForgotPassword";
import FacebookIcon from "@mui/icons-material/Facebook";
import {SocialType} from "../../_genApi/gameDeploy";

const Card = styled(MuiCard)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignSelf: 'center',
	width: '100%',
	padding: theme.spacing(4),
	gap: theme.spacing(2),
	boxShadow:
		'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
	[theme.breakpoints.up('sm')]: {
		width: '450px',
	},
	// ...theme.applyStyles('dark', {
	// 	boxShadow:
	// 		'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
	// }),

	background:
		'hsla(220, 35%, 100%, 0.9)',
	// ...theme.applyStyles('dark', {
	// 	background:
	// 		'hsla(220, 35%, 3%, 0.4)',
	// }),
}));


const MyLoadingButton = styled(LoadingButton)(({ theme }) => ({
	color: 'white',
	// ...theme.applyStyles('dark', {
	// 	color: 'black',
	// }),
}));

export default function SignInCard({ onLoggedIn, onClose }: { onLoggedIn?: () => void; onClose?: () => void }) {
	const signInContext = useContext(SignInContext);
	const navigate = useNavigate();

	const [emailError, setEmailError] = React.useState(false);
	const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
	const [passwordError, setPasswordError] = React.useState(false);
	const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');
	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		if (emailError || passwordError) {
			event.preventDefault();
			return;
		}
		const data = new FormData(event.currentTarget);
		// console.log({
		// 	email: data.get('email'),
		// 	password: data.get('password'),
		// });
	};

	const validateInputs = () => {
		const email = document.getElementById('email') as HTMLInputElement;
		const password = document.getElementById('password') as HTMLInputElement;

		let isValid = true;

		if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
			setEmailError(true);
			setEmailErrorMessage('Please enter a valid email address.');
			isValid = false;
		} else {
			setEmailError(false);
			setEmailErrorMessage('');
		}

		if (!password.value || password.value.length < 6) {
			setPasswordError(true);
			setPasswordErrorMessage('Password must be at least 6 characters long.');
			isValid = false;
		} else {
			setPasswordError(false);
			setPasswordErrorMessage('');
		}

		return isValid;
	};

	React.useEffect(() => {
		loadGisScript().catch(() => {});
	}, []);

	const [loginGoogleStarted, setLoginGoogleStarted] = useState(false);
	const [loginFailureReason, setLoginFailureReason] = useState('');
	const signInWithGoogle = (ev) => {
		if (loginGoogleStarted) return;

		onClose?.();   // close the modal immediately
		setLoginFailureReason('');
		setLoginGoogleStarted(true);
		Auth.userReLogin(SocialType.GOOGLE)
			.then(() => {
				setLoginGoogleStarted(false);
				onLoggedIn?.();
			})
			.catch(err => {
				setLoginGoogleStarted(false);
				console.error('Login failure', err);
				setLoginFailureReason('Login failure, possibly no internet connection!');
			})
	}
	return (
		<Card variant="outlined" id={'SignInCard'}>
			<Box sx={{ display: { xs: 'flex', md: 'none' } }}>
				<SitemarkIcon />
			</Box>
			<Typography
				component="h1"
				variant="h4"
				sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)', textAlign: 'center' }}
			>
				Sign in
			</Typography>
			<Divider/>
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
				<Button
					fullWidth
					variant="outlined"
					onPointerDown={signInWithGoogle}
					startIcon={<GoogleIcon />}
				>
					Sign in with Google
				</Button>
				{/*<Button*/}
				{/*	fullWidth*/}
				{/*	variant="outlined"*/}
				{/*	onPointerDown={() => alert('Sign in with Facebook')}*/}
				{/*	startIcon={<FacebookIcon />}*/}
				{/*>*/}
				{/*	Sign in with Facebook*/}
				{/*</Button>*/}
			</Box>
		</Card>
	);
}
